import { useEffect } from 'react'

// Google Ads Conversion ID
const GOOGLE_ADS_ID = 'AW-17906837366'

const GoogleAdsScript = () => {
  useEffect(() => {
    // Só carrega em produção
    const isProduction = import.meta.env.PROD

    if (!isProduction) {
      console.log('[Google Ads] Não carregado - ambiente de desenvolvimento')
      return
    }

    // Verifica se já foi carregado para evitar duplicação
    if (document.getElementById('google-ads-script')) {
      return
    }

    // Inicializa o dataLayer
    ;(window as any).dataLayer = (window as any).dataLayer || []
    function gtag(...args: any[]) {
      ;(window as any).dataLayer.push(arguments)
    }
    ;(window as any).gtag = gtag

    gtag('js', new Date())
    gtag('config', GOOGLE_ADS_ID)

    // Carrega o script do Google Ads de forma assíncrona
    const script = document.createElement('script')
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ADS_ID}`
    script.async = true
    script.id = 'google-ads-script'

    document.head.appendChild(script)

    return () => {
      const existingScript = document.getElementById('google-ads-script')
      if (existingScript) {
        existingScript.remove()
      }
    }
  }, [])

  return null
}

export default GoogleAdsScript
